/**
 * Input Formatting Utilities
 * Auto-format IC numbers and phone numbers as user types
 */

/**
 * Format IC number to XXXXXX-XX-XXXX pattern
 * @param {string} value - Input value
 * @returns {string} - Formatted IC number
 */
export const formatIcNumber = (value) => {
  if (!value) return '';
  
  // Remove all non-digit characters except letters (for old IC format)
  const cleaned = value.replace(/[^0-9A-Za-z]/g, '');
  
  // If it starts with a letter, it's old format - return as is
  if (/^[A-Za-z]/.test(cleaned)) {
    return cleaned;
  }
  
  // Only format if we have digits
  const digits = cleaned.replace(/[^0-9]/g, '');
  
  if (digits.length <= 6) {
    return digits;
  } else if (digits.length <= 8) {
    return `${digits.substring(0, 6)}-${digits.substring(6)}`;
  } else {
    return `${digits.substring(0, 6)}-${digits.substring(6, 8)}-${digits.substring(8, 12)}`;
  }
};

/**
 * Format phone number to XXX-XXXXXXX or XXX-XXXXXXXX pattern
 * @param {string} value - Input value
 * @returns {string} - Formatted phone number
 */
export const formatPhoneNumber = (value) => {
  if (!value) return '';
  
  // Remove all non-digit characters
  const digits = value.replace(/[^0-9]/g, '');
  
  if (digits.length <= 3) {
    return digits;
  } else if (digits.length <= 10) {
    return `${digits.substring(0, 3)}-${digits.substring(3)}`;
  } else {
    // Limit to 11 digits (XXX-XXXXXXXX)
    return `${digits.substring(0, 3)}-${digits.substring(3, 11)}`;
  }
};

/**
 * Strip formatting from IC number (return digits only)
 * @param {string} value - Formatted IC number
 * @returns {string} - Digits only
 */
export const stripIcFormat = (value) => {
  if (!value) return '';
  return value.replace(/[^0-9]/g, '');
};

/**
 * Strip formatting from phone number (return digits only)
 * @param {string} value - Formatted phone number
 * @returns {string} - Digits only
 */
export const stripPhoneFormat = (value) => {
  if (!value) return '';
  return value.replace(/[^0-9]/g, '');
};
